
import { Nav } from './Nav';
import { Footer } from './Footer';
import {TermsData} from './TermsData';

export const Terms = () => {

  return (
    <div className="relative overflow-hidden">
        <Nav />
        <TermsData />
      <Footer />
    </div>
  );
};